import React from 'react';
import { useTranslation } from 'react-i18next';

/** 工作室原图批量勾选：勾选全选，取消全不选 */
export default function AiStudioSourceSelectAll({
  total = 0,
  selectedCount = 0,
  onChange,
  disabled = false,
  className = '',
}) {
  const { t } = useTranslation('workbench');
  const checked = total > 0 && selectedCount === total;

  return (
    <label className={`img2img-studio__select-all${className ? ` ${className}` : ''}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        disabled={disabled || total === 0}
        aria-label={t('studioChrome.selectAll')}
      />
      <span>{t('studioChrome.selectAll')}</span>
    </label>
  );
}
